// extracted by mini-css-extract-plugin
module.exports = {"root":"MainContentPlaceholder_root__rbU7V"};